import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ContactRequestQuotation } from './contact-request-quotation';
import { HttpService } from './service/http.service';
import { Language } from './language';
import { QuotationTemplate } from './quotation-template';
import { QuotationTemplateProduct } from './quotation-template-product';
import { School } from './school';

@Injectable({
  providedIn: 'root'
})
export class QuotationTemplateService {

  public activateEditDialog = false;


  constructor(
    private httpService : HttpService
  ) { }

  saveContactRequestQuotationAsTemplate(quotation: ContactRequestQuotation, school: School, language: Language, templateName: string){
    let template = new QuotationTemplate(
      templateName,
      quotation.description, 
      quotation.comment, 
      quotation.baseCurrency, 
      [], 
      quotation.priceIncludes, 
      quotation.priceNotIncludes, 
      school,
      language,
      quotation.secondCurrency);
      for(let product of quotation.productList){
        template.products.push(new QuotationTemplateProduct(
          product.productType,
          product.description,
          product.amount,
          product.currency
        ));
      }
    return this.httpService.postQuotationTemplate(template);
  }

  saveBookingPreConfirmationFormAsTemplate(preConfirmationForm: FormGroup, school: School, language: Language, templateName: string){
    let template = new QuotationTemplate(
      templateName,
      preConfirmationForm.value.description, 
      preConfirmationForm.value.comment, 
      preConfirmationForm.value.baseCurrency, 
      this.getProductsFromPreConfirmationForm(preConfirmationForm), 
      preConfirmationForm.value.priceIncludes, 
      preConfirmationForm.value.priceNotIncludes, 
      school,
      language,
      preConfirmationForm.value.secondCurrency);
    return this.httpService.postQuotationTemplate(template);
  }

  getProductsFromPreConfirmationForm(form: FormGroup){
    let products = [];
    let productForms = form.get("products") as FormArray;
    for(let productForm of productForms.controls){
      products.push(new QuotationTemplateProduct(
        productForm.value.type,
        productForm.value.description,
        productForm.value.amount,
        productForm.value.currency
      ));
    }
    return products;
  }
}
